import React from 'react';
import EmdbButtom from "../../../EmdbButtom";
//IMG
import okimg from "../../../../assets/img/ok.png";

//CSS
import styles from "./VTConfirmDialog.module.less";


function VTConfirmDialog({visible,onClose,onAccept,t}) {

  if (!visible) return null;

  return (
    <div className={styles.confirmdialog}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.text}>{t('vtconfirmdialog.Su producto se ha añadido al carro')}</div>
          <div className={styles.img}><img src={okimg} /></div>
          <div className={styles.buttons}>
            <span className={styles.button}><EmdbButtom label={t("vtconfirmdialog.Seguir comprando")} onClick={onClose} /></span>
            <span className={styles.button}><EmdbButtom label={t("vtconfirmdialog.Finalizar compra")} onClick={onAccept} /></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VTConfirmDialog;
/*
<span className={styles.button} onClick={onClose}>{t('Seguir comprando')}</span>
<span className={styles.button} onClick={onAccept}>{t('Finalizar compra')}</span>*/